import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ComboParticipanteReuniao } from '../../../../../core/combo-participante-reuniao';
import { ParticipanteReuniao } from '../../../../../core/participante-reuniao';
import { Reuniao } from '../../../../../core/reuniao';
import { DataUtilService } from '../../../../../services/commons/data-util.service';
import { ToastService } from '../../../../../services/toast/toast.service';

@Component({
  selector: 'cadastrar-participantes-reuniao',
  templateUrl: './cadastrar-participantes-reuniao.component.html',
  styleUrls: ['./cadastrar-participantes-reuniao.component.css']
})
export class CadastrarParticipantesReuniaoComponent implements OnInit {

  @Input() reuniao: Reuniao;
  @Output() onAbertoFormAdicaoParticipante = new EventEmitter();
  participanteReuniao: ParticipanteReuniao = new ParticipanteReuniao();

  isAtualizar: Boolean = false;

  constructor(
    private dataUtilService: DataUtilService, private toastService: ToastService
  ) { }

  ngOnInit() {
    // this.iniciarObjetos();
  }


  iniciarObjetos() {
    this.participanteReuniao = new ParticipanteReuniao();
  }

  isParticipanteJaAdicionado(): boolean {
    const participanteAdicionado: ParticipanteReuniao = this.getParticipanteDaLista();

    return !!participanteAdicionado;
  }

  getParticipanteDaLista(): ParticipanteReuniao {
    return this.reuniao.participantes.find((p: ParticipanteReuniao) => 
      p.nome === this.participanteReuniao.nome && p.origem === this.participanteReuniao.origem);
  }


  adicionar() {
    if (this.isParticipanteJaAdicionado()) {
      this.toastService.showAlerta('Participante já adicionado');
      return;
    }
    const participanteReuniao = new ParticipanteReuniao();
    Object.assign(participanteReuniao, this.participanteReuniao);

    if (!this.reuniao.participantes) {
      this.reuniao.participantes = [];
    }

    this.reuniao.participantes.push(participanteReuniao);
    this.fecharFormAdicaoParticipante();
  }

  private fecharFormAdicaoParticipante() {
    this.onAbertoFormAdicaoParticipante.emit(false);
  }

  atualizar() {
    const participanteDaLista: ParticipanteReuniao = this.getParticipanteDaLista(); 
    const index = this.reuniao.participantes.indexOf(participanteDaLista);
    this.reuniao.participantes.splice(index, 1, this.participanteReuniao);
    this.isAtualizar = false;
    this.iniciarObjetos();
  }

  atualizarParticipante(participanteReuniao: ParticipanteReuniao) {
    this.isAtualizar = true;
    this.participanteReuniao = participanteReuniao;
  }

  cancelar() {
    this.iniciarObjetos();
    this.isAtualizar = false;
    this.fecharFormAdicaoParticipante();
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onNomeParticipanteChangeReuniao(registro: ComboParticipanteReuniao) {
    Object.assign(this.participanteReuniao, registro);
  }

}
